import { IMAGES } from "@/lib/brand";
import { useReveal } from "@/lib/useReveal";
import { Stars } from "lucide-react";

export default function StickerGlow() {
  const r = useReveal();
  return (
    <section
      id="sticker-glow"
      data-testid="sticker-glow-section"
      className="py-24 sm:py-32 bg-[#3B2A22] text-[#FFFDF9] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 grid lg:grid-cols-12 gap-12 items-center">
        <div ref={r.ref} className={`lg:col-span-7 space-y-7 ${r.className}`}>
          <div className="section-label" style={{ color: "#D7B899" }}>
            Experiență signature
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Transformă bronzul într-o{" "}
            <em className="italic text-[#B88746]">experiență distractivă</em>
          </h2>
          <p className="text-[#FFFDF9]/80 leading-relaxed max-w-2xl">
            Înainte de aplicarea spray tan-ului poți alege stickere speciale pentru piele.
            După dezvoltarea bronzului, acestea lasă modele originale și creative pe piele.
            Perfect pentru vacanțe, festivaluri, petreceri sau pur și simplu pentru ceva diferit.
          </p>

          <div className="grid sm:grid-cols-3 gap-4 pt-2">
            {["Inimi & stele", "Forme botanice", "Modele personalizate"].map((t) => (
              <div
                key={t}
                className="flex items-center gap-3 border border-[#D7B899]/25 rounded-xl px-4 py-3"
              >
                <Stars size={16} className="text-[#B88746]" />
                <span className="text-sm">{t}</span>
              </div>
            ))}
          </div>

          <div className="pt-4">
            <a
              href="#rezervare"
              data-testid="sticker-glow-cta"
              className="btn-primary"
            >
              Rezervă Sticker Glow
            </a>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative img-zoom rounded-[2rem] overflow-hidden border border-[#D7B899]/20 shadow-[0_40px_80px_-40px_rgba(0,0,0,0.6)]">
            <img
              src={IMAGES.stickerGlow}
              alt="Sticker Glow Experience — model cu fluture creat prin spray tan organic"
              className="w-full h-auto block"
              data-testid="sticker-glow-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
